import OrdersEntity from '@/entities/api/orders/orders'
import { io, Socket } from 'socket.io-client'
import { API_KEY_CLEAN } from '../api/keys'

interface OrderSocketPayload {
	type: 'NEW_ORDER'
	order: OrdersEntity
	timestamp: string
}

interface ServerToClientEvents {
	connected: (data: { message: string; timestamp: string }) => void
	pong: (data: { timestamp: number }) => void
	stats: (data: any) => void
	newOrder: (data: OrderSocketPayload) => void
	paymentUpdate: (data: any) => void
	orderStatusChange: (data: any) => void
}

interface ClientToServerEvents {
	ping: () => void
	getStats: () => void
}

export const connectSocket = (
	token: string
): Socket<ServerToClientEvents, ClientToServerEvents> => {
	const socket = io(`${API_KEY_CLEAN}/orders`, {
		auth: {
			token,
		},
		withCredentials: true,
		transports: ['websocket'],
	})

	return socket
}
